module.exports = "<div class=\"modal-header\">\n  <h4 class=\"modal-title\">{{title}}</h4>\n  <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"close(false)\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <p>Are you sure want to delete this?</p>\n</div>\n<div class=\"modal-footer\">\n  <button type=\"button\" class=\"btn btn-primary\" (click)=\"close(true)\">Yes</button>\n  <button type=\"button\" class=\"btn btn-secondary\" (click)=\"close(false)\">No</button>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/modal/modal.component.html
// module id = 614
// module chunks = 1